import React from 'react';

function Results({ results, onReset }) {
  const generateResults = () => {
    const resultTexts = {
      personality: [
        "You prefer structured environments and logical decision-making.",
        "You work well independently and value organization.",
        "Consider careers in: Analysis, Engineering, Project Management"
      ],
      skills: [
        "You have strong communication and technical skills.",
        "You approach problems systematically and analytically.",
        "Consider developing: Leadership, Advanced technical skills"
      ],
      interests: [
        "You're motivated by personal growth and making a difference.",
        "You enjoy working with both data and people.",
        "Consider careers in: Consulting, Data Science, Human Resources"
      ],
      tech: [
        "You have solid technical foundations.",
        "You're interested in modern development practices.",
        "Consider roles in: Software Development, DevOps, Product Management"
      ],
      healthcare: [
        "You show strong empathy and care for others.",
        "You're interested in making a positive health impact.",
        "Consider roles in: Nursing, Healthcare Administration, Medical Research"
      ],
      finance: [
        "You have analytical thinking and financial acumen.",
        "You're comfortable with data-driven decisions.",
        "Consider roles in: Financial Analysis, Investment Banking, Risk Management"
      ]
    };

    return resultTexts[results.type] || ["Assessment completed successfully!"];
  };

  const exportToPDF = () => {
    const content = `
CAREER ASSESSMENT REPORT
========================
Assessment: ${results.title}
Date: ${new Date(results.date).toLocaleDateString()}

RESULTS:
${generateResults().join('\n')}

Generated by Career Assessment Tools
    `;
    
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `assessment-${results.type}-${new Date().toISOString().split('T')[0]}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div id="results-container">
      <h2>Your Results</h2>
      <div id="results-content">
        {generateResults().map((result, index) => (
          <div key={index} className="result-item">{result}</div>
        ))}
      </div>
      <div className="action-buttons">
        <button onClick={exportToPDF}>Export PDF</button>
        <button onClick={onReset}>Take Another Assessment</button>
      </div>
    </div>
  );
}

export default Results;